import directives from './module';
import {LandingTemplateSvc} from '../services/landingTemplateSvc';

class Logo implements ng.IComponentController {
    product: AnimatronProduct;
    logoStyle: anm.LogoStyle;
    islogoClickable: boolean;
    isLink: boolean;
    additionalLogo: string;
    href: string;
    openInNewWindow: boolean;

    constructor(private $location: ng.ILocationService,
                private landingTemplateSvc: LandingTemplateSvc) {
        this.islogoClickable = this.isLink || this.landingTemplateSvc.isLink;
    }

    logoHandler() {
        if (this.isLink || this.landingTemplateSvc.isLink) {
            const url = this.href ? this.href : '/wave';

            if (this.openInNewWindow) {
                window.open(`${window.location.origin}${url}`, '_blank');
            } else {
                this.$location.path(url);
            }
        }
    }
}

directives.component('logo', {
    bindings: {
        product: '@',
        logoStyle: '@',
        additionalLogo: '@',
        isLink: '<?',
        href: '<?',
        openInNewWindow: '<?'
    },
    controller: Logo,
    template: `<div class="animatron-logo product-{{ $ctrl.product }} style-{{ $ctrl.logoStyle }}"
                    ng-click="$ctrl.logoHandler()"
                    ng-class="{'is-clickable': $ctrl.islogoClickable}"
                    data="{{ $ctrl.additionalLogo }}"
               ><i></i></div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/Logo.ts